module.exports = __webpack_public_path__ + "img/in-stock.510fdfe3.png";